module.exports = {
	name: 'head-nav',
	data() {
		return {};
	},
	methods: {
		logout() {
			this.$store.dispatch('update_userinfo', {});
		}
	}
};


// WEBPACK FOOTER //
// ./src/components/Common/HeadNav/HeadNav.js